import { DataItem } from './types';
import { Row } from '@tanstack/react-table';
import randomColor from 'randomcolor';

export const formatLowerthird = (data: DataItem[], isLoading: boolean) => {
  const colorMap: { [key: string]: string } = {};
  if (!isLoading && data) {
    return data?.map((item: DataItem) => {
      if (!colorMap[item.text]) {
        colorMap[item.text] = randomColor({ luminosity: 'bright' });
      }
      return { ...item, color: colorMap[item.text] };
    });
  }
};

export const filterLowerthird = (row: Row<any>, text: string, filterValue: string) => {
  const value = row.getValue(text);
  if (typeof value === 'string') {
    return value.toLowerCase().includes(filterValue.toLowerCase());
  }
  return false;
};
